import { Button, HStack } from '@genial/components';
import React from 'react';

import { NewContractSteps } from '../../types';

interface FooterActionsProps {
  currentStep: NewContractSteps;
  isContinueDisabled: boolean;
  isSendDisabled: boolean;
  onContinue: () => void;
  onCancel: () => void;
  onSend: () => void;
}

export const FooterActions: React.FC<FooterActionsProps> = ({
  currentStep,
  isContinueDisabled,
  isSendDisabled,
  onContinue,
  onCancel,
  onSend,
}) => {
  if (currentStep === 1) {
    return (
      <HStack
        p="inset.xs"
        w="full"
        bg="neutral.white"
        borderTopWidth={1}
        borderTopColor="neutral.lightest">
        <Button onPress={onContinue} isDisabled={isContinueDisabled} w="full">
          Continuar
        </Button>
      </HStack>
    );
  }

  return (
    <HStack
      p="inset.xs"
      w="full"
      bg="neutral.white"
      borderTopWidth={1}
      borderTopColor="neutral.lightest"
      justifyContent="space-between"
      space="inline.xxxs">
      <Button variant="secondary" onPress={onCancel} flex={1}>
        Cancelar
      </Button>
      <Button variant="callToAction" onPress={onSend} isDisabled={isSendDisabled} flex={1}>
        Enviar
      </Button>
    </HStack>
  );
};
